package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel
import com.example.mystybag.sharedmodels.project.requestModels.merchant.BagAllergenItem

enum class BagSegment {
    ACTIVE,
    ENDED
}

data class BagListItem(
    val bagId: Long,
    val locationId: Long,
    val locationName: String,
    /** Optional display title for the bag. */
    val title: String? = null,
    val availableCount: Int,
    val totalCount: Int,
    val price: Double,
    val currency: String,
    val activeFrom: String? = null,
    val activeTo: String? = null,
    /** Formatted for card display, e.g. "23 Jan 2026". */
    val activeToFormatted: String = "",
    /** Formatted for card display, e.g. "23 Jan 2026". */
    val activeFromFormatted: String = "",
    /** Formatted for card display, e.g. "23 Jan 2026, 12:30". */
    val createdOnFormatted: String = ""
)

data class BagDetails(
    val bagId: Long,
    val locationId: Long,
    val locationName: String,
    /** Optional display title for the bag. */
    val title: String? = null,
    val availableCount: Int,
    val reservedCount: Int,
    val totalCount: Int,
    val priceNormal: Double,
    val priceWithDiscount: Double,
    val currency: String,
    val activeTo: String? = null,
    val activeFrom: String? = null,
    val createdAt: String? = null,
    val allergens: List<BagAllergenItem> = emptyList()
)

data class BagsUIState(
    val isLoading: Boolean = false,
    val bagIdPendingDeactivate: Long? = null,
    val selectedLocationId: Long? = null, // null = "All"
    val selectedSegment: BagSegment = BagSegment.ACTIVE,
    val locations: List<MerchantLocationResponseModel> = emptyList(),
    /** All bags from API; tabs are shown when this is not empty so user can switch back from empty Inactive list. */
    val allBags: List<BagListItem> = emptyList(),
    val bags: List<BagListItem> = emptyList(),
    val selectedBagDetails: BagDetails? = null,
    /** Always true for merchant owner; for staff this comes from the per-user permission flag. Hides Add bag actions when false. */
    val canCreateBags: Boolean = true
)

